export const dbPosMap = {
    1: "SW",
    2: "S",
    3: "SE",
    4: "W",
    6: "E",
    7: "NW",
    8: "N",
    9: "NE",
};
//# sourceMappingURL=dbPosMap.js.map